import { render, staticRenderFns } from "./TtPressRelease.vue?vue&type=template&id=aa800686"
import script from "./TtPressRelease.vue?vue&type=script&lang=ts"
export * from "./TtPressRelease.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports